import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  Button,
  Card,
  CardBody,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import Columns4 from "../Columns4";
import Select from "react-select";
import { useEffect, useState } from "react";
import { idAdministrador, idVisualizador } from "../../Utility/roles";

const ControlVisualPrincipal = ({
  ShowOpenDocument,
  setShowOpenDocument,
  setSelectedObjectDocument,
  SelectedObjectDocument,
  getPageData4,
  assignedForDocumentId,
  handlePageChange4,
  handleAceptarDocument,
  currentPage4,
  pageSize4,
  sizePerPageList,
  handleSizePerPageChange4,
  role,
  getRejectionReasonAll,
  rejectionReason,
  setPageSize4,
  setCurrentPage4
}) => {

  const [Rechazar,setRechazar] = useState(false);
  const [RejectionReasonOptions,setRejectionReasonOptions] = useState([]);

  useEffect( ()=> {
    if (ShowOpenDocument==false) {
      setRechazar(false);
      setPageSize4(5)
      setCurrentPage4(1)
    }
  },[ShowOpenDocument])


  

  useEffect(() => {
    if (rejectionReason) {
      setRejectionReasonOptions(
        rejectionReason.map((x) => ({ value: x.id, label: x.description }))
      );
    }
   
  }, [rejectionReason]);

  return (
    <Modal
      key={"open"}
      size="xl"
      fade={false}
      centered={true}
      isOpen={ShowOpenDocument}
      toggle={() => {
        setShowOpenDocument(!ShowOpenDocument);
        setSelectedObjectDocument(null);
      }}
      backdrop="static"
      keyboard={false}
    >
      <ModalHeader
        toggle={() => {
          setShowOpenDocument(!ShowOpenDocument);
          setSelectedObjectDocument(null);
        }}
      >
        Control visual
      </ModalHeader>
      <ModalBody>
        <Col lg={12}>
          <Card>
            <CardBody>
              <Row>
                <Col lg={7} md={12}>
                  <iframe
                    id="miIframe"
                    width="100%"
                    height="500px"
                    src={`${process.env.REACT_APP_URL}Document/File?PathFile=${assignedForDocumentId?.file}`}
                  ></iframe>
                </Col>
                <Col lg={5} md={12}>
                  <Row>
                    <Col lg={12}>
                      <BootstrapTable
                        key={"custom_table"}
                        remote={true}
                        pagination={
                          getPageData4().length > 0
                            ? paginationFactory({
                                page: currentPage4,
                                sizePerPage: pageSize4,
                                totalSize:
                                  assignedForDocumentId &&
                                  assignedForDocumentId?.attachs.length,
                                sizePerPageList: sizePerPageList,
                                onSizePerPageChange: handleSizePerPageChange4,
                              })
                            : null
                        }
                        onTableChange={handlePageChange4}
                        columns={Columns4()}
                        data={getPageData4()}
                        keyField={"itemId"}
                        responsive={true}
                        bordered={false}
                        striped={true}
                        classes={
                          "table align-middle table-nowrap table-sm customTable"
                        }
                        noDataIndication={
                          <span className="no-data-message">
                            No hay datos disponibles
                          </span>
                        }
                        headerWrapperClasses={"thead-light"}
                      />
                    </Col>
                    <Col lg={12} className="p-3">
                     <p>Observación:</p> 

                     <textarea style={{width:"100%"}} className="p-2 form-control" value={assignedForDocumentId?.observation} disabled={true}></textarea>
                    </Col>

                    <Col lg={12}>
                   
                      <hr class="my-3" />

                      {SelectedObjectDocument?.estado === "Completo" &&
                        (role.id === idAdministrador || role.id === idVisualizador) && (
                          <div className="justify-content-around d-flex mt-4">
                            <Button
                              type="button"
                              className="btn"
                              color="success"
                              onClick={() => {
                                handleAceptarDocument(1);
                              }}
                            >
                              Aceptar
                            </Button>
                            <Button
                              className="btn"
                              type="button"
                              color="danger"
                              onClick={() => {

                                getRejectionReasonAll({setRechazar})
                                // setRechazar(true);
                                
                              }}
                            >
                              Rechazar
                            </Button>
                          </div>
                        )}
                        {Rechazar&& (
                           <section className="contentControlVisualRechazo mt-4">
                           <div className="justify-content-around d-flex gap-3">
                             <Select
                               className="form-control resetearControlSelect flex-fill "
                               classNamePrefix="select2-selection"
                               value={RejectionReasonOptions.find(option => option.value == SelectedObjectDocument?.valueTypeMensajeRechazo)}
                               placeholder="Seleccione"
                               onChange={(x) =>{
                               
                                setSelectedObjectDocument({
                                  ...SelectedObjectDocument,
                                  valueTypeMensajeRechazo: x?.value,
                                 
                                });
                              
                              }}
   
                                options={RejectionReasonOptions}
                             />
   
                             <Button
                               type="button"
                               className="btn flex-fill"
                               color="primary"
                               onClick={() => {
                                handleAceptarDocument(2);
                               }}
                             >
                               Confirmar
                             </Button>
                           </div>
                           <div className="mt-4">
                           <hr class="my-3" />
                             <textarea
                               id="basicpill-address-input1"
                               className="form-control mt-4 mb-4"
                               rows="5"
                            
                               placeholder={"Mensaje de Rechazo "}
                              
                               value={SelectedObjectDocument?.observation}
                              
                               disabled={
                                !(SelectedObjectDocument?.estado ==="Completo" &&
                                 role.id === idAdministrador || role.id === idVisualizador)
                               }
                               onChange={(e) => {
                                 if (
                                   !(SelectedObjectDocument?.estado ==="Completo" &&
                                 role.id === idAdministrador || role.id === idVisualizador)
                                 ) {
                                   return;
                                 }
                                 const inputValue = e.target.value;
       
                                 // Reemplaza múltiples espacios en blanco entre palabras con un solo espacio en blanco
                                 const sanitizedInput = inputValue.replace(
                                   /\s+/g,
                                   " "
                                 );
       
                                 // Verifica si el valor contiene al menos un carácter diferente de un espacio en blanco o si es una cadena vacía
                                 if (
                                   /^\s*$/.test(sanitizedInput) ||
                                   sanitizedInput.length > 0
                                 ) {
                                   setSelectedObjectDocument({
                                     ...SelectedObjectDocument,
                                     observation: sanitizedInput,
                                     observationlng: sanitizedInput.length,
                                   });
                                 }
                               }}
                             ></textarea>
                             <hr class="my-3" />
                           </div>
                         </section>
                        )}
                     
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </ModalBody>
    </Modal>
  );
};

export default ControlVisualPrincipal;
